module.exports = __webpack_public_path__ + "img/totegamma.1b59871f.png";